import(/* webpackMode: "eager" */ "/app/apps/frontend/app/error.tsx");
